import { nativeResponseRequest } from "@smartling/requester";

export async function validateUniqEmail(email: string): Promise<boolean> {
    const result: { response: { code: string } } = await nativeResponseRequest({
        method: "GET",
        url: `/registration/selfservice/account/email/validate.ajax?email=${encodeURIComponent(email)}&action=checkUniqueness`
    }).then(data => data.json());

    return result.response.code === "SUCCESS";
}
